// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';
import { Vod } from '../../types/Model';
import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface InitState {
  vodListData: Vod[];
  isLoading: boolean;
  totalPage: number;
  error?: Error;
}

const { getVodListActions } = actionCreatorsList;
export const initialState: InitState = {
  vodListData: [],
  isLoading: true,
  totalPage: 1
};

export default function (state = initialState, action: RootAction) {
  switch (action.type) {
    case getType(getVodListActions.request): {
      return {
        ...state,
        isLoading: true,
        error: undefined
      };
    }
    case getType(getVodListActions.success): {
      const { listData, totalPage } = action.payload;

      return {
        ...state,
        isLoading: false,
        listData,
        totalPage
      };
    }
    case getType(getVodListActions.failure): {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }

    default: {
      return state;
    }
  }
}
